export default function RubleOutlineIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='10'
            height='14'
            viewBox='0 0 9 11'
            fill='none'
            {...props}
        >
            <path
                d='M5.6875 6.36754H0.517045V5.27379H5.6875C6.16477 5.27379 6.55919 5.19093 6.87074 5.02521C7.18229 4.85618 7.4143 4.62749 7.56676 4.33913C7.71922 4.04747 7.79545 3.71603 7.79545 3.34482C7.79545 2.9736 7.71922 2.64382 7.56676 2.35547C7.4143 2.0638 7.18229 1.83511 6.87074 1.66939C6.55919 1.50035 6.16477 1.41584 5.6875 1.41584H3.3608V10.5039H2.12784V0.322088H5.6875C6.44318 0.322088 7.06629 0.459635 7.55682 0.73473C8.04735 1.00982 8.41193 1.37607 8.65057 1.83345C8.8892 2.29084 9.00852 2.79463 9.00852 3.34482C9.00852 3.895 8.8892 4.39879 8.65057 4.85618C8.41193 5.31357 8.04735 5.67981 7.55682 5.9549C7.06629 6.23 6.44318 6.36754 5.6875 6.36754ZM5.60795 7.32209V8.41584H0.517045V7.32209H5.60795Z'
                fill='#282A42'
            />
        </svg>
    )
}
